var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestCr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6501 6.34817C40.7384 3.43667 36.018 3.43682 33.1068 6.34849L8.2108 31.2473C7.36428 32.094 6.76928 33.1588 6.49199 34.3235L4.20951 43.9098C4.08384 44.4377 4.24099 44.9929 4.62466 45.3767C5.00834 45.7602 5.56359 45.9175 6.09143 45.7917L15.6774 43.5094C16.8424 43.2321 17.9075 42.6367 18.7543 41.7898L39.5826 20.9592C40.9955 22.3838 40.992 24.6842 39.5718 26.1044L35.8564 29.8198C35.2462 30.43 35.2462 31.4192 35.8564 32.0294C36.4666 32.6396 37.4557 32.6396 38.0659 32.0294L41.7816 28.314C44.422 25.6735 44.4257 21.3944 41.7922 18.7493L43.6503 16.8909C46.5614 13.9795 46.5614 9.25944 43.6501 6.34817ZM35.3166 8.55807C37.0074 6.8669 39.7493 6.86682 41.4403 8.55788C43.1312 10.2488 43.1314 12.9903 41.4405 14.6813L16.5445 39.5802C16.1067 40.0181 15.5559 40.3258 14.9536 40.4694L7.83764 42.1636L9.53201 35.0473C9.67536 34.4452 9.98299 33.8946 10.4206 33.4569L35.3166 8.55807Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCr);
export default __webpack_public_path__ + "static/media/request-cr.2190748ffd07c7703eda0c13b4ecba2a.svg";
export { ForwardRef as ReactComponent };